export enum StoreNames {
  AUTHENTICATION_STORE = 'authentication',
  NOTIFICATIONS_STORE = 'notifications',
  BUSINESS_ACCOUNT_STORE = 'businessAccount',
  BUSINESS_ACCOUNT_PERSISTED_STORE = 'businessAccountPersisted',
  ROLES_PERMISSIONS_STORE = 'rolesPermissions',
  NON_PERSISTED_STATE_STORE = 'nonPersistedState',
}
